import React, {useState, useContext} from 'react';
import {Card, Grid, TextField, Button} from '@material-ui/core';
import {Form, Formik} from 'formik';
import DialogBox from '../../../../components/DialogBox';

import {ThemeContext} from '../../../../themes/ThemeProvider';
import SearchEventTactics from '../EventTacticSearch';
import AddEventClientTable from './AddEventClientTable';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const AddEventClient = ({setValue, setEventTacticCode, eventTacticCode}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const [eventSearchOpen, setEventSearchOpen] = useState(false);
  const [eventClientData, setEventClientData] = useState('');

  const handleEventSearchClose = () => {
    setEventSearchOpen(false);
  };
  const initialValues = {
    eventType: [],
    isClientCode: false,
    clientCode: '',
    eventTactic: '',
    clientApplied: '',
  };
  const eventTypeOptions = [
    {value: 'Debtor User-Defined Window Updated'},
    {value: 'Disposition Change'},
    {value: 'New Business Approved'},
    {value: 'Phase Change'},
    {value: 'Number of Calls Updated'},
    {value: 'Debtor Cash Transaction Updated'},
    {value: 'Letter Requested'},
    {value: 'Letter Sent'},
    {value: 'Receipt of NSF'},
  ];
  const clientAppliedOptions = [{value: 'Agency'}, {value: 'Client'}];

  const onSubmit = (data, {resetForm}) => {};

  return (
    <>
      <Card className={`${classes.tabCardStyles} mb-0`}>
        <Formik
          onSubmit={(values, props) => onSubmit(values, props)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, setFieldValue, handleBlur} = props;

            return (
              <Form>
                <Grid spacing={2} container>
                  <Grid
                    item
                    md={4} sm={6}
                    className={`form-group ${classes.selectdropdown}`}
                  >
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                        popper: classes.popper,
                      }}
                      name="event"
                      id="eventType"
                      size="small"
                      value={values.eventType}
                      options={eventTypeOptions}
                      getOptionLabel={(option) => {
                        return option && option.valueCode && option.value ?
                          option.valueCode + ' - ' + option.value :
                          option.value === null ?
                            option.valueCode :
                            option.value;
                      }}
                      required
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('eventType', value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Event Type"
                            placeholder="Select Event Type"
                          />
                        </div>
                      )}
                    />
                  </Grid>

                  <Grid item md={4} sm={6} className="form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Event Tactic`}
                      label="Event Tactic"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="eventTactic"
                      value={values.eventTactic}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <Button
                            variant="contained"
                            className={` ${classes.filterGroupButton}`}
                            size="sm"
                            onClick={() => setEventSearchOpen(true)}
                          >
                            Search
                          </Button>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item
                    md={4} sm={6}
                    className={`px-1 form-group ${classes.selectdropdown}`}
                  >
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                        popper: classes.popper,
                      }}
                      name="event"
                      id="clientApplied"
                      size="small"
                      value={values.clientApplied}
                      options={clientAppliedOptions}
                      getOptionLabel={(option) => {
                        return option && option.value ?
                          option.value :
                          option.value === null ?
                            option.valueCode :
                            option.value;
                      }}
                      required
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('clientApplied', value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="Client Tactics Applied To"
                            placeholder="Select Client Tactics Applied To"
                          />
                        </div>
                      )}
                    />
                  </Grid>
                  {values?.clientApplied?.value === 'Client' ? (
                    <Grid item md={4} sm={6} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Client Code`}
                        label="Client Code"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="clientCode"
                        value={values.clientCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                  ) : null}
                </Grid>

                <AddEventClientTable
                  setEventClientData={setEventClientData}
                  eventClientData={eventClientData}
                  handleChange={handleChange}
                  values={values}
                  setFieldValue={setFieldValue}
                />
                <div className="row justify-content-center mt-3">
                  <Button variant="contained" className={`mx-1 ${classes.buttonRoot}`}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
        <div>
          <DialogBox
            open={eventSearchOpen}
            dialogClose={() => handleEventSearchClose()}
            title="Event Tactic"
            maxWidth="lg"
          >
            <SearchEventTactics
              handleClose={handleEventSearchClose}
              setEventClientData={setEventClientData}
              eventClientData={eventClientData}
            />
          </DialogBox>
        </div>
      </Card>
    </>
  );
};

export default AddEventClient;
